import { UserFollow } from '@carbon/icons-react';
import { defineSection } from '@/app/registry';

/**
 * Лиды (БО-03; DODOC_ADMIN, DODOC_SUPPORT): заявки с сайта и из обзвона, воронка, следующее действие, причины
 * отказа, импорт списка клиник из Excel по шаблону плана захода, конверсия лида в клинику.
 */
export const section = defineSection({
  id: 'backoffice.leads',
  area: 'backoffice',
  path: 'leads/*',
  roles: ['DODOC_ADMIN', 'DODOC_SUPPORT'],
  icon: UserFollow,
  titleKey: 'boLeads:title',
  namespaces: ['portal', 'backoffice'],
  navGroup: 'clients',
  order: 20,
  load: () => import('./LeadsPage'),
});
